/** O mapa de modelos do `useViewer` e o registo do `viewerApi` andam em
 *  paralelo: o carregamento escreve nos dois, mas quem descarrega um
 *  modelo (remover na barra lateral, fechar sessão, modo substituir)
 *  só passa pelo `viewerApi.disposeModel`, que não conhece o mapa do
 *  hook. O mapa ficava com modelos já descartados: a decisão de
 *  enquadrar a câmara contava-os, a reaplicação da georreferenciação
 *  mexia neles e o desmontar do viewer descartava-os segunda vez.
 *
 *  Isto põe o mapa de acordo com o registo. Puro, para se poder testar
 *  sem WebGL. */
export function largarModelosDescartados<T>(
  locais: Map<string, T>,
  aindaRegistado: (id: string) => boolean,
): string[] {
  const largados: string[] = []
  for (const id of Array.from(locais.keys())) {
    if (!aindaRegistado(id)) {
      locais.delete(id)
      largados.push(id)
    }
  }
  return largados
}
